import { Response } from '@marketplace-web/core-api/api-client-util'

import {
  ClosetPromotionPricingDto,
  ClosetPromotionPricingModel,
  ClosetPromotionPricingResp,
  ClosetPromotionPricingSvcVasDto,
  ClosetPromotionPricingSvcVasResp,
} from '../types/closet-promotion-pricing'
import { transformCurrencyAmountDto, transformCurrencyDto } from './currency'

export const transformClosetPromotionPricing = (
  dto: ClosetPromotionPricingDto,
): ClosetPromotionPricingModel => ({
  effectiveDays: dto.effective_days,
  isSalesTaxApplicable: dto.sales_tax_applicable,
  totalPrice: transformCurrencyAmountDto(dto.total_price),
  pricePerDay: transformCurrencyAmountDto(dto.price_per_day),
  discountedPrice: transformCurrencyAmountDto(dto.discounted_price),
})

export const transformClosetPromotionPricingResponse = (
  response: Response<ClosetPromotionPricingResp>,
): ClosetPromotionPricingModel => transformClosetPromotionPricing(response.promoted_closet_pricing)

export const transformClosetPromotionPricingSvcVas = (
  dto: ClosetPromotionPricingSvcVasDto,
): ClosetPromotionPricingModel => ({
  effectiveDays: dto.effective_days,
  isSalesTaxApplicable: dto.sales_tax_applicable,
  totalPrice: transformCurrencyDto(dto.total_price),
  discountedPrice: transformCurrencyDto(dto.discounted_price),
  pricePerDay: transformCurrencyDto(dto.price_per_day),
})
export const transformClosetPromotionPricingSvcVasResponse = (
  response: Response<ClosetPromotionPricingSvcVasResp>,
): ClosetPromotionPricingModel =>
  transformClosetPromotionPricingSvcVas(response.promoted_closet_pricing)
